import { Table } from '@tanstack/react-table';
import { useMemo, useRef } from 'react';

import { useDialogs } from '@work4all/components';

import { useUser } from '@work4all/data';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { canAddUser } from '@work4all/utils/lib/permissions';

import { useOpenMask } from '../../../containers/mask-overlays/mask-overlay/hooks/use-open-mask';
import { EntityTableLayoutV8Props } from '../table/EntityTableLayoutV8';
import { useTableHandlersV8 } from '../use-table-handlers-v8';

import { CreateUserAction } from './CreateUserAction';

const entityType = Entities.fullUser;

export const useUserActions = ({ table }: { table: Table<unknown> }) => {
  const rootRef = useRef(null);
  const dialogs = useDialogs();

  const onOpenMask = useOpenMask({ entityType });
  const tableHandlers = useTableHandlersV8(table, entityType, onOpenMask);

  const user = useUser();
  return useMemo<EntityTableLayoutV8Props['actions']>(() => {
    return {
      add: {
        title: 'Add',
        handler: () => {
          const { id } = dialogs.open(CreateUserAction, {
            rootRef,
            onCreate: (userKind) => tableHandlers.create.handler({ userKind }),
            onClose: () => {
              dialogs.close(id);
            },
          });
        },
        rootRef,
        mode: 'Add',
        disabled: !canAddUser(user),
      },
      remove: {
        maxCount: 1,
        handler: () => {},
        disabled: true,
      },
    };
  }, [dialogs, tableHandlers.create, user]);
};
